import * as React from 'react';
import classNames from 'classnames';
import {
  ColorStyleProps,
  FontSizeProps,
  FontWeightProps,
} from '../../../@types/theme';

import styles from './Subtitle.module.scss';

export interface Props
  extends Omit<React.HTMLAttributes<HTMLElement>, 'color'> {
  as?: 'p' | 'span';
  size?: FontSizeProps;
  color?: ColorStyleProps;
  weight?: FontWeightProps;
  children: React.ReactNode;
  isUpperCase?: boolean;
  ellipsize?: boolean;
}

export const Subtitle: React.FC<Props> = ({
  className,
  style,
  children,
  size,
  as = 'p',
  weight,
  color,
  isUpperCase = false,
  ellipsize = false,
  ...htmlElementProps
}) => {
  const Component = as;

  const cls = classNames(styles.text, className, {
    [`subtitle-${size}`]: size,
    [`text-${color}`]: color,
    [`fw-${weight}`]: weight,
    ellipsize,
  });

  return (
    <Component
      className={cls}
      style={{ textTransform: isUpperCase ? 'uppercase' : 'inherit', ...style }}
      title={typeof children === 'string' ? children : undefined}
      {...htmlElementProps}
    >
      {children}
    </Component>
  );
};

export default Subtitle;
